










































import Vue from "vue";
import OlMap from "./components/OlMap.vue";
import SelectorYear from "./components/SelectorYear.vue";
import ToggleDataType from "./components/ToggleDataType.vue";
import SelectorPollutant from "./components/SelectorPollutant.vue";
import SelectorGnfr from "./components/SelectorGnfr.vue";
import ToggleLanguageButtons from "./components/ToggleLanguageButtons.vue";
import GnfrDescription from "./components/GnfrDescription.vue";
import MuniDataDownloadAll from "./components/MuniDataDownloadAll.vue";
import { Pollutant, MapDataType, Gnfr, TotalEmissionStats } from "./types";
import { Dispatch } from "./store";
import * as env from "./env";

export default Vue.extend({
  components: {
    OlMap,
    SelectorYear,
    SelectorGnfr,
    SelectorPollutant,
    ToggleDataType,
    ToggleLanguageButtons,
    GnfrDescription,
    MuniDataDownloadAll
  },
  data() {
    return {
      year: env.latestYear as number,
      gnfr: undefined as Gnfr | undefined,
      pollutant: undefined as Pollutant | undefined,
      mapDataType: MapDataType.GRID as MapDataType,
      totalEmissionStats: undefined as TotalEmissionStats | undefined,
      downloadFullDataEnabled: env.downloadFullDataEnabled as boolean
    };
  },
  beforeCreate() {
    this.$store.dispatch(Dispatch.loadSetInitialLang);
  }
});
